import MenuSm from './MenuSm';

export default MenuSm;
